import React from 'react';
import PopupEditRow from '../PopupEditRow/PopupEditRow';

export function EditColumnFormatter(cellContent) {
  return (
    <PopupEditRow
      canCreate={cellContent?.canCreate}
      allowInvoiceDeal={cellContent?.allowInvoiceDeal}
      status={cellContent?.status}
      invoiceOrderID={cellContent?._id}
    />
  );
}
